import { Theme } from './theme.js'
import { ThemeQuery } from './theme-query.js'
import { ThemeMutation } from './theme-mutation.js'

export const entities = [Theme]
export const resolvers = [ThemeQuery, ThemeMutation]
export const subscribers = []
